import { useEffect, useState } from 'react'
import AdRecruitSelectType from './AdRecruitSelectType'
import AdRecruitSelectStatus from './AdRecruitSelectStatus'
import styled from 'styled-components'
import { ActionButton, NextButton } from '../common/CommonStyled'
import AddIcon from '@mui/icons-material/Add';
import { useAdRecruitStore } from 'src/stores/AdRecruitStore'
import { useModalStore } from 'src/stores/ModalStore'
import ModalTitleAddSchedule from './ModalTitleAddSchedule'
import ModalContentAddSchedule from './ModalContentAddSchedule'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AdRecruitCalendar from './AdRecruitCalendar'

const PageWrapper = styled.div`
    padding: 20px;
`
const TopWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
`
const DropBoxWrapper = styled.div`
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
`
const CalendarComponentWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
`
const CalendarComponentSpan = styled.span`
    font-weight: 600;
    font-size: 20px;
`
const Recruit_Calendar = () => {
    const setField = useAdRecruitStore((state)=>state.setField)
    const modalSetField = useModalStore((state)=>state.setField)

    const today = new Date()
    const [currentdate,setCurrentdate] = useState<Date|undefined>(today)
    const year = currentdate?.getFullYear();
    const month = currentdate ? currentdate.getMonth() + 1 : '';

    useEffect(()=>{
        setField('currnetdate',currentdate)
    },[currentdate])

    const onClickPrevMonth = () => {
        setCurrentdate((prev) => {
            if (!prev) return today; // prev가 undefined면 오늘로 초기화
            const prevDate = new Date(prev);
            prevDate.setMonth(prevDate.getMonth() - 1);
            return prevDate;
        });
    };

    const onClickNextMonth = () => {
        setCurrentdate((prev) => {
            if (!prev) return today; // prev가 undefined면 오늘로 초기화
            const prevDate = new Date(prev);
            prevDate.setMonth(prevDate.getMonth() + 1);
            return prevDate;
        });
    };

    const onClickSetToday = ()=>{
        setField('currnetdate',today)
        setCurrentdate(today)
    }
    
    const onClickAddSchedule = ()=>{
        modalSetField('type','CENTER')
        modalSetField('width','1024px')
        modalSetField('title', <ModalTitleAddSchedule/>)
        modalSetField('content',<ModalContentAddSchedule/>)
        modalSetField('open',true)
    }

    return (
        <PageWrapper>
            <TopWrapper>
                <DropBoxWrapper>
                    <AdRecruitSelectType/>
                    <AdRecruitSelectStatus/>
                </DropBoxWrapper>
                <CalendarComponentWrapper>
                    <ActionButton style={{width:'44px', height:'44px'}} onClick={onClickPrevMonth}>
                        <ArrowBackIcon sx={{color:'#508A9C', fontSize:'30px'}}/>
                    </ActionButton>
                    <CalendarComponentSpan>
                        {year}년 {month}월
                    </CalendarComponentSpan>
                    <ActionButton style={{width:'44px', height:'44px'}} onClick={onClickNextMonth}>
                        <ArrowForwardIcon sx={{color:'#508A9C', fontSize:'30px'}}/>
                    </ActionButton>
                    <ActionButton style={{width:'94px'}} onClick={onClickSetToday}>
                        오늘
                    </ActionButton>
                </CalendarComponentWrapper>
                <NextButton style={{width:'120px',maxHeight:'47px'}} onClick={onClickAddSchedule}>
                    <div style={{display:'flex',justifyContent:'center', alignItems:'center', gap:'8px'}}>
                        <AddIcon/> 일정등록
                    </div>
                </NextButton>
            </TopWrapper>
            <AdRecruitCalendar/>
        </PageWrapper>
    )
}

export default Recruit_Calendar